import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`flex items-center justify-between px-8 md:px-16 py-4 sticky top-0 z-[60]
      transition-all duration-300 ease-in-out
      ${scrolled
        ? 'bg-white/70 backdrop-blur-xl border-b border-gray-200/50 shadow-sm'
        : 'bg-transparent border-b border-transparent'
      }`}
    >
      {/* Logo */}
      <Link
        to="/"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="flex items-center gap-2.5"
      >
        <svg viewBox="0 0 80 72" className="w-8 h-7" fill="none" strokeWidth="1.8" strokeLinejoin="miter">
          <rect x="30" y="6" width="20" height="54" fill="#C8CDD4"/>
          <rect x="36" y="14" width="8" height="16" fill="#0F0F0F"/>
          <path d="M8 60 L8 32 L26 22 L26 60" stroke="#0A0A0A"/>
          <path d="M46 60 L46 36 L60 24 L74 36 L74 60" stroke="#0A0A0A"/>
          <line x1="4" y1="60" x2="78" y2="60" stroke="#0A0A0A"/>
        </svg>
        <div>
          <div className="text-xs font-semibold tracking-[.22em] text-black uppercase leading-none">IBR PERÚ</div>
          <div className="text-[9px] tracking-[.36em] text-gray-400 uppercase">BIENES RAÍCES</div>
        </div>
      </Link>

      {/* Nav links */}
      <div className="hidden md:flex items-center gap-6 text-sm text-gray-500 font-medium">
        {[
          { label: 'El Proyecto',      href: '#el-proyecto' },
          { label: 'Comodidades',       href: '#comodidades' },
          { label: 'Especificaciones', href: '#especificaciones' },
          { label: 'Invertir',         href: '#invertir' },
          { label: 'Contacto',         href: '#contacto' },
        ].map(({ label, href }) => (
          <a key={label} href={href} className="hover:text-black transition-colors">{label}</a>
        ))}
      </div>

      {/* Right — call button + presentación */}
      <div className="flex items-center gap-2">

        {/* Llamar — outlined, no fill */}
        <a
          href="tel:+51965194210"
          className="flex items-center gap-1.5 text-xs font-medium text-gray-700
            border border-gray-400 rounded-full px-4 py-2
            hover:border-gray-900 hover:text-black transition-all duration-200"
        >
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 4h4l2 5-2.5 1.5a11 11 0 005 5L15 13l5 2v4a2 2 0 01-2 2A15 15 0 013 6a2 2 0 012-2z"/>
          </svg>
          Llamar
        </a>

        <div className="hidden md:block w-px h-5 bg-gray-300 mx-1" />

        {/* Ver presentación — filled */}
        <Link
          to="/presentacion"
          className="hidden md:flex items-center gap-2 bg-black text-white text-xs font-semibold
            tracking-wide px-4 py-2.5 rounded-full
            hover:bg-black/80 hover:shadow-lg hover:-translate-y-0.5
            transition-all duration-300 active:scale-95"
        >
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M7 17L17 7M17 7H7M17 7v10" />
          </svg>
          Ver presentación
        </Link>

      </div>
    </nav>
  );
}

